import * as React from "react";

import { QuestionProps } from "../../model";

import { DropdownQuestion } from "./DropdownQuestion";

export const YesNoUnknownDropdownQuestion: React.FC<QuestionProps> = (props) => {
    return (
        <DropdownQuestion
            {...props}
            options={[
                { value: "Yes", text: "Yes" },
                { value: "No", text: "No" },
                { value: "Unknown", text: "Unknown" }
            ]}
        />);
};
